import React from 'react';
import styled, {css} from "styled-components";

const Wrapper = styled.div`
    background-color: ${props => props.backgroundColor};
    height: ${props => props.height || "100%"};
    padding: ${props => props.padding || "46px 0 56px"};
    margin-top: ${props => props.marginTopWrapper};
    margin-bottom: ${props => props.marginBottomWrapper};

    ${props => props.theme.mediaQueries.medium}{
        padding: ${props => props.paddingMediaQueriesMedium};
        margin-top: ${props => props.marginTopWrapperMediaQueriesMedium};
    }
`
const Content = styled.div`
    margin-left: ${props => props.marginLeft || 'auto'};
    margin-right: ${props => props.marginRight || 'auto'};
    max-width: ${props => props.maxWidth || '335px'};

    ${props => props.theme.mediaQueries.medium}{
        max-width: ${props => props.maxWidthMediaQueriesMedium || '720px'};
    }

    ${props => props.theme.mediaQueries.large}{
        max-width: ${props => props.maxWidthMediaQueriesLarge};
    }
`

const BackgroundColorContainer = ({ 
    children,
    image,
    ...props
}) => {
    return (
        <Wrapper {...props}>
            {image}
            <Content {...props}>
                    {children}
            </Content>          
        </Wrapper>
    )
}

export default BackgroundColorContainer;